import Vue                      from "vue";
import { IPartAddRequestDto }   from "@/types";
import LoadingSpinner           from "@/components/Elements/LoadingSpinner.vue";
import { PartSearchService }    from "@/services/";
import { mapGetters }           from "vuex";

export default Vue.extend({
    name: "SuggestPart",
    components: {
        LoadingSpinner
    },
    data: () => ({
        partAddRequest: {} as IPartAddRequestDto,
        isSubmittingRequest: false
    }),

    computed: {
        ...mapGetters(["user"])
    },

    methods: {
        SendSuggestPart() {
            let successMsgLine1 = "Thank you for your valued input! Your request has been submitted to our Product Development Department<br /><br />";
            let successMsgLine2 = "A Product Development Analyst may soon contact you about your request.";
            this.isSubmittingRequest = true;
            this.partAddRequest.ExternalUserId = this.user.UserId
            this.partAddRequest.Email = this.user.Email
            this.partAddRequest.Name = this.user.FullName
            this.partAddRequest.DealerCode = this.user.DealerCode
            this.partAddRequest.Phone = this.user.Phone
            PartSearchService.PartAddRequest(this.partAddRequest).then(response => {
                this.$parent.HideSuggestPart()
            }).finally(() => {
                this.isSubmittingRequest = false;
                this.$store.commit("pushTimedMessage", {
                    header: `Success`,
                    message: `${successMsgLine1}${successMsgLine2}`,
                    IsError: false,
                    seconds: 5
                })
            })
        }
    }
})